var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnavailableV2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 156,
    viewBox: "0 0 266 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1129_18793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.5 90.1602H248.5V99.1602H257.5V90.1602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 53.5195H9V62.5195H18V53.5195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 44.4492H0V53.4492H9V44.4492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.861 42.3203L219.781 135.9L218.341 141.28L217.771 143.42L217.061 146.06C216.191 149.29 213.681 152.11 210.671 153.61C209.331 154.29 207.891 154.7 206.451 154.77C206.301 154.78 206.161 154.78 206.011 154.78C201.191 154.78 198.341 150.87 199.631 146.06L200.601 142.44L227.431 42.3203H244.861Z",
    fill: "#DFDAFF",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.951 154.78H196.301L224.551 49.3496H234.761L206.661 154.24C206.571 154.56 206.281 154.78 205.951 154.78Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.401 154.78H197.301L225.551 49.3398H230.661L202.401 154.78Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74 37.4094V37.4494L227.43 42.3194L200.6 142.439L199.63 146.059C198.34 150.869 201.19 154.779 206.01 154.779H23.0898L58.5098 22.6094H109.03L105.06 37.4094H228.74Z",
    fill: "#DFDAFF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.891 67.4902C103.481 71.0302 117.141 89.6902 117.141 89.6902L100.891 67.4902Z",
    fill: "#E5F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.891 67.4902C103.481 71.0302 117.141 89.6902 117.141 89.6902",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.089 67.4902C118.599 71.0302 94.9395 89.6902 94.9395 89.6902L123.089 67.4902Z",
    fill: "#E5F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.089 67.4902C118.599 71.0302 94.9395 89.6902 94.9395 89.6902",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.689 67.4902C153.279 71.0302 166.939 89.6902 166.939 89.6902L150.689 67.4902Z",
    fill: "#E5F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.689 67.4902C153.279 71.0302 166.939 89.6902 166.939 89.6902",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89 67.4902C168.4 71.0302 144.74 89.6902 144.74 89.6902L172.89 67.4902Z",
    fill: "#E5F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89 67.4902C168.4 71.0302 144.74 89.6902 144.74 89.6902",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.299 129.6C140.329 122.16 133.169 117.26 123.549 117.26C113.929 117.26 104.159 122.17 97.1895 129.6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7394 55.1409C69.3086 55.1409 81.1194 43.3301 81.1194 28.7609C81.1194 14.1916 69.3086 2.38086 54.7394 2.38086C40.1701 2.38086 28.3594 14.1916 28.3594 28.7609C28.3594 43.3301 40.1701 55.1409 54.7394 55.1409Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2491 53.26C66.8184 53.26 78.6291 41.4493 78.6291 26.88C78.6291 12.3107 66.8184 0.5 52.2491 0.5C37.6799 0.5 25.8691 12.3107 25.8691 26.88C25.8691 41.4493 37.6799 53.26 52.2491 53.26Z",
    fill: "#E81CEC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8998 36.4899C57.1198 35.9899 57.3998 35.5799 57.7698 35.2199C58.1398 34.8599 58.5598 34.5799 59.0598 34.3699C59.5598 34.1499 60.0698 34.0399 60.6098 34.0399C61.1498 34.0399 61.6898 34.1499 62.1698 34.3699C62.6498 34.5899 63.0698 34.8699 63.4398 35.2199C63.8098 35.5799 64.0898 35.9899 64.3098 36.4899C64.5298 36.9899 64.6198 37.5099 64.6198 38.0699C64.6198 38.6299 64.5098 39.1699 64.3098 39.6499C64.1098 40.1299 63.8098 40.5599 63.4398 40.9199C63.0698 41.2799 62.6498 41.5599 62.1698 41.7699C61.6898 41.9899 61.1598 42.0799 60.6098 42.0799C60.0598 42.0799 59.5598 41.9699 59.0598 41.7699C58.5598 41.5499 58.1298 41.2699 57.7698 40.9199C57.4098 40.5599 57.1198 40.1499 56.8998 39.6499C56.6798 39.1499 56.5898 38.6299 56.5898 38.0699C56.5898 37.5099 56.6998 36.9899 56.8998 36.4899ZM63.3898 11.9199V32.5399H57.8098V11.9199H63.3898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2006 36.4899C40.4206 35.9899 40.7006 35.5799 41.0706 35.2199C41.4406 34.8599 41.8606 34.5799 42.3606 34.3699C42.8606 34.1499 43.3706 34.0399 43.9106 34.0399C44.4506 34.0399 44.9906 34.1499 45.4706 34.3699C45.9506 34.5899 46.3706 34.8699 46.7406 35.2199C47.1106 35.5799 47.3906 35.9899 47.6106 36.4899C47.8306 36.9899 47.9206 37.5099 47.9206 38.0699C47.9206 38.6299 47.8106 39.1699 47.6106 39.6499C47.4106 40.1299 47.1106 40.5599 46.7406 40.9199C46.3706 41.2799 45.9506 41.5599 45.4706 41.7699C44.9906 41.9899 44.4606 42.0799 43.9106 42.0799C43.3606 42.0799 42.8606 41.9699 42.3606 41.7699C41.8606 41.5499 41.4306 41.2699 41.0706 40.9199C40.7106 40.5599 40.4206 40.1499 40.2006 39.6499C39.9806 39.1499 39.8906 38.6299 39.8906 38.0699C39.8906 37.5099 40.0006 36.9899 40.2006 36.4899ZM46.6906 11.9199V32.5399H41.1106V11.9199H46.6906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38 116.109L209.76 128.159L225.38 140.209H265.2V116.109H225.38Z",
    fill: "#CCF6FB",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.601 127.811C240.061 127.811 240.481 127.721 240.851 127.531C241.221 127.351 241.541 127.101 241.801 126.781C242.061 126.471 242.261 126.101 242.411 125.691C242.551 125.271 242.621 124.841 242.621 124.391C242.621 123.661 242.381 123.051 241.881 122.541C241.391 122.031 240.681 121.781 239.741 121.781C238.731 121.781 237.881 122.101 237.181 122.731C236.491 123.371 236.021 124.231 235.791 125.351L235.591 126.291H233.711L233.941 125.221C234.281 123.631 234.961 122.371 235.981 121.441C237.001 120.511 238.331 120.051 239.971 120.051C240.651 120.051 241.281 120.161 241.851 120.371C242.411 120.581 242.901 120.881 243.301 121.251C243.701 121.621 244.021 122.061 244.241 122.561C244.471 123.071 244.581 123.621 244.581 124.211C244.581 124.851 244.471 125.491 244.241 126.121C244.011 126.761 243.691 127.321 243.261 127.821C242.831 128.321 242.291 128.721 241.661 129.041C241.031 129.351 240.301 129.511 239.481 129.511H239.211C238.761 129.511 238.491 129.731 238.411 130.181L238.071 131.831H236.281L236.731 129.731C236.851 129.121 237.101 128.651 237.501 128.311C237.891 127.971 238.421 127.811 239.071 127.811H239.611H239.601ZM235.051 134.731C235.051 134.301 235.201 133.931 235.511 133.621C235.821 133.311 236.181 133.161 236.621 133.161C237.061 133.161 237.421 133.311 237.731 133.621C238.041 133.931 238.191 134.291 238.191 134.731C238.191 135.171 238.041 135.531 237.731 135.841C237.421 136.151 237.061 136.301 236.621 136.301C236.181 136.301 235.821 136.151 235.511 135.841C235.201 135.531 235.051 135.171 235.051 134.731Z",
    fill: "#0C0F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.47 127.811C253.93 127.811 254.35 127.721 254.72 127.531C255.09 127.351 255.41 127.101 255.67 126.781C255.93 126.471 256.13 126.101 256.28 125.691C256.42 125.271 256.49 124.841 256.49 124.391C256.49 123.661 256.25 123.051 255.75 122.541C255.26 122.031 254.55 121.781 253.61 121.781C252.6 121.781 251.75 122.101 251.05 122.731C250.36 123.371 249.89 124.231 249.66 125.351L249.46 126.291H247.58L247.81 125.221C248.15 123.631 248.83 122.371 249.85 121.441C250.87 120.511 252.2 120.051 253.84 120.051C254.52 120.051 255.15 120.161 255.72 120.371C256.28 120.581 256.77 120.881 257.17 121.251C257.57 121.621 257.89 122.061 258.11 122.561C258.34 123.071 258.45 123.621 258.45 124.211C258.45 124.851 258.34 125.491 258.11 126.121C257.88 126.761 257.56 127.321 257.13 127.821C256.7 128.321 256.16 128.721 255.53 129.041C254.9 129.351 254.17 129.511 253.35 129.511H253.08C252.63 129.511 252.36 129.731 252.28 130.181L251.94 131.831H250.15L250.6 129.731C250.72 129.121 250.97 128.651 251.37 128.311C251.76 127.971 252.29 127.811 252.94 127.811H253.48H253.47ZM248.92 134.731C248.92 134.301 249.07 133.931 249.38 133.621C249.69 133.311 250.05 133.161 250.49 133.161C250.93 133.161 251.29 133.311 251.6 133.621C251.91 133.931 252.06 134.291 252.06 134.731C252.06 135.171 251.91 135.531 251.6 135.841C251.29 136.151 250.93 136.301 250.49 136.301C250.05 136.301 249.69 136.151 249.38 135.841C249.07 135.531 248.92 135.171 248.92 134.731Z",
    fill: "#0C0F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.78 135.9L218.34 141.28L217 146L209.76 128.16L219.78 135.9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1129_18793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265.7,
    height: 155.28,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnavailableV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unavailable_v2.ce0f6fec3a64ca6ada225feaf3f7de40.svg";